document.addEventListener('DOMContentLoaded', (event) => {
  // Get the sidebar and the buttons
  const mySidebar = document.getElementById("custom-sidebar__container");
  const openSidebarButton = document.getElementById("custom-sidebar__open-button");
  const closeSidebarButton = document.getElementById("custom-sidebar__close-button");

  // Open sidebar
  openSidebarButton.addEventListener('click', () => {
    mySidebar.style.width = "100%"; // Open to full width on mobile
  });

  // Close sidebar
  closeSidebarButton.addEventListener('click', () => {
    mySidebar.style.width = "0"; // Close the sidebar on mobile
  });
});
